export default __webpack_public_path__ + "static/epica-lite-3-7ca3c294c77195e4ed08dcf020cf932f.jpg";